/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S3_Services_BodyInputs */

const tr_mesafeli_s3_services_body = /** @type {(inputs: Mesafeli_S3_Services_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Çoklu pazaryeri yönetimi, e-Fatura entegrasyonu (QNB eSolutions), kargo entegrasyonu (Geliver), AI tabanlı otomasyon, mesajlaşma, finansal raporlama ve ilgili tüm modüller.`)
};

const en_mesafeli_s3_services_body = /** @type {(inputs: Mesafeli_S3_Services_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multi-marketplace management, e-Fatura integration (QNB eSolutions), shipping integration (Geliver), AI-based automation, messaging, financial reporting and all related modules.`)
};

const de_mesafeli_s3_services_body = /** @type {(inputs: Mesafeli_S3_Services_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwaltung mehrerer Marktplätze, e-Fatura-Integration (QNB eSolutions), Versandintegration (Geliver), AI-gestützte Automatisierung, Nachrichtenversand, Finanzberichte und alle zugehörigen Module.`)
};

const ru_mesafeli_s3_services_body = /** @type {(inputs: Mesafeli_S3_Services_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Управление несколькими маркетплейсами, интеграция e-Fatura (QNB eSolutions), интеграция доставки (Geliver), автоматизация на базе AI, обмен сообщениями, финансовая отчётность и все связанные модули.`)
};

/**
* | output |
* | --- |
* | "Multi-marketplace management, e-Fatura integration (QNB eSolutions), shipping integration (Geliver), AI-based automation, messaging, financial reporting and ..." |
*
* @param {Mesafeli_S3_Services_BodyInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s3_services_body = /** @type {((inputs?: Mesafeli_S3_Services_BodyInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S3_Services_BodyInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s3_services_body(inputs)
	if (locale === "de") return de_mesafeli_s3_services_body(inputs)
	if (locale === "ru") return ru_mesafeli_s3_services_body(inputs)
	return tr_mesafeli_s3_services_body(inputs)
});